// material
import { Box, BoxProps, useTheme } from '@mui/material';

// ----------------------------------------------------------------------

export interface LogoProps extends BoxProps {
  onlyLogo?: boolean;
}
export default function Logo(props: LogoProps) {
  const { sx, onlyLogo } = props;

  const theme = useTheme();

  const PRIMARY_LIGHT = theme.palette.primary.light;

  return (
    <Box sx={{ width: '100%', height: 40, ...sx }}>
      {onlyLogo ? (
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          style={{
            marginTop: 16,
            width: '100%',
            height: '100%'
          }}
          viewBox="0 0 1020 2120"
          preserveAspectRatio="xMidYMid meet"
        >
          <g
            transform="translate(0.000000,1489.000000) scale(0.100000,-0.100000)"
            fill={`${PRIMARY_LIGHT}`}
            stroke="none"
          >
            <path
              d="M13 14867 c14 -38 2489 -3543 2546 -3606 251 -281 599 -463 981 -512
76 -9 6573 -14 6578 -4 1 3 2 934 2 2070 l0 2065 -5056 0 c-4212 0 -5055 -2
-5051 -13z"
            />
            <path
              d="M81 9502 c-6 -2 -3 -11 4 -20 8 -9 1501 -2143 3318 -4741 1816 -2598
3306 -4724 3310 -4725 4 -1 7 1162 7 2584 0 2487 1 2587 19 2625 22 50 70 91
120 105 26 7 564 9 1655 8 l1616 -3 0 2085 0 2085 -5020 0 c-2761 0 -5024 -1
-5029 -3z"
            />
          </g>
        </svg>
      ) : (
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 439.48 55.81"
          preserveAspectRatio="xMidYMid meet"
        >
          <g fill={`${PRIMARY_LIGHT}`} stroke="none">
            <rect className="cls-1" x="328.69" y="20.04" width="8.53" height="31.68" />
            <rect className="cls-1" x="328.69" y="10.85" width="8.53" height="7.04" />
            <path
              className="cls-1"
              d="M73.89,20H65.36V51.72l8.53-16.6h9.28a4.07,4.07,0,0,0,3.34-1.74l3.93-5.58H73.89Z"
            />
            <path
              className="cls-1"
              d="M65.36,18.18H87a4.11,4.11,0,0,0,3.35-1.74l3.92-5.58H65.36Z"
            />
            <path
              className="cls-1"
              d="M166.12,18.12h20.62a4.09,4.09,0,0,0,3.34-1.74L194,10.85H166.12Z"
            />
            <path
              className="cls-1"
              d="M186.65,44.45h-12V34.38h14.12V27.05H174.65V20h-8.53V51.72h27.75v0L190,46.19A4.07,4.07,0,0,0,186.65,44.45Z"
            />
            <path
              className="cls-1"
              d="M141.6,29.85A13.91,13.91,0,0,0,143,23.21a14.72,14.72,0,0,0-.68-4.32,9.89,9.89,0,0,0-2.47-4A12.85,12.85,0,0,0,135,12a24,24,0,0,0-7.93-1.11H112.58v7h14.31a13.15,13.15,0,0,1,3.69.43,5.69,5.69,0,0,1,2.29,1.2,4.31,4.31,0,0,1,1.18,1.78,6.57,6.57,0,0,1,.34,2.08,9.53,9.53,0,0,1-.29,2.41A4,4,0,0,1,133,27.65a5.1,5.1,0,0,1-2.09,1.2,10.7,10.7,0,0,1-3.32.43H121V20h-8.41V51.72H121V36.38h8l6.15,13.73a2.71,2.71,0,0,0,2.48,1.61h7.45l-8.3-17.34A11.34,11.34,0,0,0,141.6,29.85Z"
            />
            <path
              className="cls-1"
              d="M235.58,44.45h-12V34.38H237.7V27.05H223.58V20h-8.53V51.72H242.8v0l-3.88-5.51A4.09,4.09,0,0,0,235.58,44.45Z"
            />
            <path
              className="cls-1"
              d="M215.05,18.12h20.61A4.11,4.11,0,0,0,239,16.38l3.89-5.53H215.05Z"
            />
            <path
              className="cls-1"
              d="M432.16,44.45h-12V34.38h14.12V27.05H420.17V20h-8.53V51.72h27.74v0l-3.88-5.51A4.11,4.11,0,0,0,432.16,44.45Z"
            />
            <path
              className="cls-1"
              d="M435.59,16.38l3.89-5.53H411.64v7.27h20.61A4.07,4.07,0,0,0,435.59,16.38Z"
            />
            <path
              className="cls-1"
              d="M388.92,29.85a13.91,13.91,0,0,0,1.43-6.64,14.72,14.72,0,0,0-.68-4.32,10,10,0,0,0-2.46-4,13,13,0,0,0-4.9-2.92,24,24,0,0,0-7.93-1.11H359.9v7h14.31a13.15,13.15,0,0,1,3.69.43,5.69,5.69,0,0,1,2.29,1.2,4.31,4.31,0,0,1,1.18,1.78,6.3,6.3,0,0,1,.34,2.08,9.53,9.53,0,0,1-.29,2.41,4,4,0,0,1-1.06,1.86,5.12,5.12,0,0,1-2.08,1.2,10.79,10.79,0,0,1-3.32.43h-6.64V20H359.9V51.72h8.42V36.38h8l6.15,13.73A2.72,2.72,0,0,0,385,51.72h7.45l-8.3-17.34A11.29,11.29,0,0,0,388.92,29.85Z"
            />
            <path
              className="cls-1"
              d="M304.54,10.86A3.66,3.66,0,0,0,301.1,14l-6,25.26-7-28.16h-7.23L291,51.72h8.3L310.4,10.85h-5.86Z"
            />
            <path
              className="cls-1"
              d="M273,39.24l-6.6-25.16a4.34,4.34,0,0,0-3.75-3.22h-5.85l11.79,40.87h8.08l6.46-26.47-3.44-14.12Z"
            />
            <path className="cls-1" d="M14,15.53H38V0H0L9.15,13A5.93,5.93,0,0,0,14,15.53Z" />
            <path className="cls-1" d="M25.18,55.81V36.47a.65.65,0,0,1,.65-.65H38V20.2H.28Z" />
          </g>
        </svg>
      )}
    </Box>
  );
}
